import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@/components/dotLoader/DotLoader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { WaveNotificationSettingsState } from "./useWaveNotificationSettings";
interface WaveNotificationPreferenceButtonsProps {
  readonly waveId: string;
  readonly settings: WaveNotificationSettingsState;
}
const getButtonStyle = (active: boolean) => {
  return active ? "tw-bg-iron-800 tw-text-primary-400 tw-font-medium" : "tw-text-iron-400 desktop-hover:hover:tw-text-iron-300 tw-bg-transparent";
};
function getAllDropsButtonStyle(settings: WaveNotificationSettingsState) {
  const buttonStyle = getButtonStyle(settings.allDropsEnabled);
  return settings.disableAllDropsSelection && !settings.allDropsEnabled ? `${buttonStyle} tw-cursor-not-allowed` : buttonStyle;
}
function AllDropsIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 1 1 0-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 0 1-1.44-4.282m3.102.069a18.03 18.03 0 0 1-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 0 1 8.835 2.535M10.34 6.66a23.847 23.847 0 0 0 8.835-2.535m0 0A23.74 23.74 0 0 0 18.795 3m.38 1.125a23.91 23.91 0 0 1 1.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 0 0 1.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 0 1 0 3.46" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default function WaveNotificationPreferenceButtons(t0) {
  const $ = _c(40);
  const {
    waveId,
    settings
  } = t0;
  const allDropsSelectionDisabled = settings.disableAllDropsSelection && !settings.allDropsEnabled;
  const allDropsTooltipId = `all-drops-tooltip-${waveId}`;
  const allDropsDisabledDescriptionId = `${allDropsTooltipId}-disabled-description`;
  const t1 = settings.loading;
  const t2 = allDropsSelectionDisabled || undefined;
  const t3 = allDropsSelectionDisabled ? allDropsDisabledDescriptionId : undefined;
  const t4 = allDropsSelectionDisabled ? undefined : settings.onAllDropsNotificationsClick;
  let t5;
  if ($[0] !== settings) {
    t5 = getAllDropsButtonStyle(settings);
    $[0] = settings;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-px-2.5 tw-py-2 tw-transition tw-duration-300 tw-ease-out lg:tw-h-9 ${t5}`;
  let t7;
  if ($[2] !== settings.loadingTarget) {
    t7 = settings.loadingTarget === "all-drops" ? <Spinner dimension={12} /> : <AllDropsIcon className="tw-size-4 tw-flex-shrink-0" />;
    $[2] = settings.loadingTarget;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== allDropsDisabledDescriptionId || $[5] !== allDropsSelectionDisabled || $[6] !== settings.allDropsTooltip) {
    t8 = allDropsSelectionDisabled && <span id={allDropsDisabledDescriptionId} className="tw-sr-only">{settings.allDropsTooltip}</span>;
    $[4] = allDropsDisabledDescriptionId;
    $[5] = allDropsSelectionDisabled;
    $[6] = settings.allDropsTooltip;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== settings.loading || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8) {
    t9 = <button type="button" disabled={t1} aria-disabled={t2} aria-describedby={t3} onClick={t4} className={t6} aria-label="Receive all drop notifications">{t7}{t8}</button>;
    $[8] = settings.loading;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const allDropsButton = t9;
  const t10 = `all-group-tooltip-${waveId}`;
  let t11;
  if ($[16] !== settings.allGroupTooltip || $[17] !== t10) {
    t11 = <Tooltip id={t10} placement="top">{settings.allGroupTooltip}</Tooltip>;
    $[16] = settings.allGroupTooltip;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = settings.loading;
  const t13 = settings.onAllGroupNotificationsClick;
  let t14;
  if ($[19] !== settings.allGroupNotificationsEnabled) {
    t14 = getButtonStyle(settings.allGroupNotificationsEnabled);
    $[19] = settings.allGroupNotificationsEnabled;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  const t15 = `tw-flex tw-h-10 tw-w-full tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-px-2.5 tw-py-2 tw-transition tw-duration-300 tw-ease-out lg:tw-h-9 ${t14}`;
  let t16;
  if ($[21] !== settings.loadingTarget) {
    t16 = settings.loadingTarget === "all-group" ? <Spinner dimension={12} /> : <span>@ALL</span>;
    $[21] = settings.loadingTarget;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== settings.loading || $[24] !== settings.onAllGroupNotificationsClick || $[25] !== t15 || $[26] !== t16) {
    t17 = <button disabled={t12} onClick={t13} className={t15} aria-label="Receive ALL mention notifications">{t16}</button>;
    $[23] = settings.loading;
    $[24] = settings.onAllGroupNotificationsClick;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t11 || $[29] !== t17) {
    t18 = <OverlayTrigger overlay={t11}>{t17}</OverlayTrigger>;
    $[28] = t11;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== allDropsTooltipId || $[32] !== settings.allDropsTooltip) {
    t19 = <Tooltip id={allDropsTooltipId} placement="top">{settings.allDropsTooltip}</Tooltip>;
    $[31] = allDropsTooltipId;
    $[32] = settings.allDropsTooltip;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== allDropsButton || $[35] !== t19) {
    t20 = <OverlayTrigger overlay={t19}>{allDropsButton}</OverlayTrigger>;
    $[34] = allDropsButton;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t18 || $[38] !== t20) {
    t21 = <div className="tw-grid tw-w-full tw-grid-cols-2 tw-gap-x-1.5 tw-text-xs">{t18}{t20}</div>;
    $[37] = t18;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  return t21;
}